import { postUserAppOnboardedMutationFn } from '@/queries/users';
import { updateUserProperty } from '@/redux/slices/user/actions';
import store from '@/redux/store';

/**
 * Record that a visitor has been through the initial setup.
 *
 * The onboarding chain that used to do this is retired: it asked for a persona the Speedy Flow
 * already asks for, and showed products the flow already shows — as a wall in front of `/home`
 * rather than as part of the journey they were on.
 *
 * The flag outlives it because something still reads it. Push-notification prompts hold off until a
 * visitor has been through setup, so with nothing setting it they would never be offered at all.
 *
 * Called from both places authentication can finish — inside the modal, and on the full-page
 * routes — because a visitor who signs up on `/signup` never touches the flow. Idempotent, and
 * fire-and-forget: failing to record it costs a push prompt, not a journey.
 */
const markAppOnboarded = () => {
  const { logged, isAppOnboarded } = store.getState().user;
  if (!logged || isAppOnboarded) {
    return;
  }
  postUserAppOnboardedMutationFn()
    .then((data) => store.dispatch(updateUserProperty(data)))
    .catch((err) => console.error('Could not record app onboarding', err));
};

export default markAppOnboarded;
